// components/playground/sections/ScenarioListItem.jsx
import React from 'react';
import { getTempRowsCount } from '../../../../utils/plScenarioHelpers';

const ScenarioListItem = ({
  scenario,
  isActive,
  hasUnsavedChanges,
  currentYear,
  currentMonth,
  onClick,
  formatRelativeTime,
}) => {
  // Calculate active vs historical adjustments for this scenario
  const scenarioActiveAdjustments = Object.keys(scenario.user_adjustments || {}).filter(key => {
    const [year, accountId, month] = key.split('-');
    const yearNum = parseInt(year);
    const monthNum = parseInt(month);
    
    if (yearNum > currentYear) return true;
    if (yearNum === currentYear && currentMonth) {
      return monthNum > currentMonth;
    }
    return false;
  }).length;
  
  const scenarioTotalAdjustments = Object.keys(scenario.user_adjustments || {}).length;
  const scenarioHistoricalAdjustments = scenarioTotalAdjustments - scenarioActiveAdjustments;
  const scenarioTempRows = getTempRowsCount(scenario.temporary_rows);

  return (
    <button
      onClick={onClick}
      className={`w-full text-left px-4 py-3 rounded-lg transition-colors ${
        isActive
          ? 'bg-green-100 border-2 border-green-500'
          : 'bg-white border-2 border-transparent hover:border-green-300'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          {/* Scenario Name */}
          <div className="font-medium text-gray-900 truncate">
            {scenario.scenario_name}
            {isActive && hasUnsavedChanges && (
              <span className="text-orange-500 ml-1">*</span>
            )}
          </div>

          {/* Description */}
          {scenario.scenario_description && (
            <div className="text-xs text-gray-500 truncate mt-1">
              {scenario.scenario_description}
            </div>
          )}
          
          {/* Changes Summary */}
          <div className="mt-2 space-y-1">
            <div className="flex items-center gap-2 text-xs">
              {/* Active Adjustments */}
              {scenarioActiveAdjustments > 0 && (
                <>
                  <span className="bg-green-100 text-green-700 px-1.5 py-0.5 rounded font-medium">
                    {scenarioActiveAdjustments}
                  </span>
                  <span className="text-gray-600">active</span>
                </>
              )}

              {/* Historical Adjustments */}
              {scenarioHistoricalAdjustments > 0 && (
                <>
                  {scenarioActiveAdjustments > 0 && <span className="text-gray-400">•</span>}
                  <span className="bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded font-medium">
                    {scenarioHistoricalAdjustments}
                  </span>
                  <span className="text-gray-500">historical</span>
                </>
              )}

              {/* Custom Rows */}
              {scenarioTempRows > 0 && (
                <>
                  {(scenarioActiveAdjustments > 0 || scenarioHistoricalAdjustments > 0) && (
                    <span className="text-gray-400">•</span>
                  )}
                  <span className="bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded font-medium">
                    {scenarioTempRows}
                  </span>
                  <span className="text-gray-500">custom</span>
                </>
              )}
            </div>

            {/* Last Updated */}
            <div className="text-xs text-gray-400">
              {formatRelativeTime(scenario.updated_at)}
            </div>
          </div>
        </div>

        {/* Active Checkmark */}
        {isActive && (
          <div className="text-green-600 font-bold flex-shrink-0">✓</div>
        )}
      </div>
    </button>
  );
};

export default ScenarioListItem;